<template>
<!--  <nav :class="classes" class="navbar">-->
<!--    <div :class="containerClasses">-->

<!--      <CollapseTransition-->
<!--        @after-leave="onTransitionEnd"-->
<!--        @before-enter="onTransitionStart"-->
<!--      >-->
<!--        <div-->
<!--          class="collapse navbar-collapse show"-->
<!--          :class="menuClasses"-->
<!--        >-->
<!--          <slot></slot>-->
<!--        </div>-->
<!--      </CollapseTransition>-->
<!--    </div>-->
<!--  </nav>-->
  <nav class="navbar"
       :class="classes">
    <div class="container">
      <slot name="container-pre"></slot>
      <slot name="brand">
        <a class="navbar-brand" href="https://www.offthecouch.io">
          <img style="width: 70px; height: 70px; padding: 0" class="card-img" src="img/otcteal_logowhite.png" alt="Image" />
        </a>
      </slot>
      <navbar-toggle-button :toggled="toggled"
                            :target="contentId"
                            @click.native.stop="toggled = !toggled">
      </navbar-toggle-button>

      <slot name="container-after"></slot>

      <div class="collapse navbar-collapse" :class="{show: toggled}" :id="contentId" v-click-outside="closeMenu">
        <div class="navbar-collapse-header">
          <slot name="content-header" :close-menu="closeMenu">
          </slot>
        </div>
        <slot :close-menu="closeMenu"></slot>
      </div>
    </div>
  </nav>
</template>
<script>
import { CollapseTransition, FadeTransition } from 'vue2-transitions';
import NavbarToggleButton from "./NavbarToggleButton";

export default {
  name: 'base-nav',
  props: {
    effect: {
      type: String,
      default: "dark",
      description: "Effect of the navbar (light|dark)"
    },
    title: {
      type: String,
      default: "",
      description: "Title of navbar"
    },
    round: {
      type: Boolean,
      default: false,
      description: "Whether nav has rounded corners"
    },
    show: {
      type: Boolean,
      default: false,
      description:
        'Whether navbar menu is shown (valid for viewports < specified by `expand` prop)'
    },
    transparent: {
      type: Boolean,
      default: false,
      description: 'Whether navbar is transparent'
    },
    contentId: {
      type: [String, Number],
      default: Math.random().toString(),
      description:
        "Explicit id for the menu. By default it's a generated random number"
    },
    expand: {
      type: String,
      default: 'lg',
      description: 'Breakpoint where nav should expand'
    },
    menuClasses: {
      type: [String, Object, Array],
      default: '',
      description:
        'Navbar menu (items) classes. Can be used to align menu items to the right/left'
    },
    containerClasses: {
      type: [String, Object, Array],
      default: 'container-fluid',
      description:
        'Container classes. Can be used to control container classes (contains both navbar brand and menu items)'
    },
    type: {
      type: String,
      default: 'white',
      validator(value) {
        return [
          'dark',
          'success',
          'danger',
          'warning',
          'white',
          'primary',
          'info',
          'vue'
        ].includes(value);
      },
      description: 'Navbar color type'
    }
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  components: {
    CollapseTransition,
    FadeTransition,
    NavbarToggleButton
  },
  data() {
    return {
      transitionFinished: true,
      scrolled: false,
      scrollThreshold: 100,
      toggled: false
    };
  },
  computed: {
    classes() {
      let color = `bg-${this.type}`;
      let classes = [
        { 'navbar-transparent': !this.show && this.transparent && !this.scrolled},
        { [`navbar-expand-${this.expand}`]: this.expand },
        {'navbar-colored': this.scrolled},
      ];
      if (this.position) {
        classes.push(`navbar-${this.position}`);
      }
      if (
        !this.transparent ||
        (this.show && !this.transitionFinished) ||
        (!this.show && !this.transitionFinished)
      ) {
        classes.push(color);
      }
      return classes;
    },
  },
  methods: {
    onTitleClick(evt) {
      this.$emit("title-click", evt);
    },
    closeMenu() {
      this.toggled = false;
    },
    toggleMenu() {
      this.$emit('change', !this.show);
    },
    onTransitionStart() {
      this.transitionFinished = false;
    },
    onTransitionEnd() {
      this.transitionFinished = true;
    },
    handleScroll() {
      this.scrolled = window.scrollY > this.scrollThreshold;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style></style>

<!--<template>-->

<!--  <nav :class="navbarClasses"  class="navbar fixed-top navbar-absolute">-->
<!--    <div class="container">-->
<!--      <div class="navbar-translate">-->
<!--        <a class="navbar-brand" href="https://www.offthecouch.io">-->
<!--          <img style="width: 70px; height: 70px; padding: 0" class="card-img" src="img/otcteal_logowhite.png" alt="Image" />-->
<!--        </a>-->
<!--      </div>-->
<!--      <CollapseTransition-->
<!--        @after-leave="onTransitionEnd"-->
<!--        @before-enter="onTransitionStart"-->
<!--      >-->
<!--        <div-->
<!--          class="collapse navbar-collapse show"-->
<!--          :class="menuClasses"-->
<!--          v-show="show"-->
<!--        >-->
<!--          <slot></slot>-->
<!--        </div>-->
<!--      </CollapseTransition>-->
<!--      <div class="collapse">-->
<!--        <div class="navbar-collapse-header">-->
<!--          <div class="row">-->
<!--            <div class="col-6 collapse-brand">-->
<!--              <a>-->
<!--                BLK•-->
<!--                <span> PRO </span>-->
<!--              </a>-->
<!--            </div>-->
<!--            <div class="col-6 collapse-close text-right">-->
<!--              <button-->
<!--                type="button"-->
<!--                class="navbar-toggler"-->
<!--                aria-controls="navigation"-->
<!--                aria-label="Toggle navigation"-->
<!--              >-->
<!--                <i class="tim-icons icon-simple-remove"></i>-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <ul class="navbar-nav ml-auto">-->
<!--          <li class="dropdown nav-item">-->
<!--            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">-->
<!--              <i class="fa fa-cogs d-lg-none d-xl-none"></i> Getting started-->
<!--            </a>-->
<!--            <div class="dropdown-menu dropdown-with-icons">-->
<!--              <a href="../index.html" class="dropdown-item">-->
<!--                <i class="tim-icons icon-paper"></i> Components-->
<!--              </a>-->
<!--              <a href="../presentation.html" class="dropdown-item">-->
<!--                <i class="tim-icons icon-bullet-list-67"></i>Presentation Page-->
<!--              </a>-->
<!--              <a-->
<!--                href="https://demos.creative-tim.com/blk-design-system-pro/docs/1.0/getting-started/overview.html"-->
<!--                class="dropdown-item"-->
<!--              >-->
<!--                <i class="tim-icons icon-book-bookmark"></i>Documentation-->
<!--              </a>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li class="nav-item dropdown">-->
<!--            <a-->
<!--              href="#"-->
<!--              class="nav-link dropdown-toggle"-->
<!--              id="navbarDropdownMenuLink"-->
<!--              data-toggle="dropdown"-->
<!--            >-->
<!--              <i class="tim-icons icon-paper" aria-hidden="true"></i>-->
<!--              <p>Sections</p>-->
<!--            </a>-->
<!--            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">-->
<!--              <a class="dropdown-item" href="../sections.html#headers">-->
<!--                <i class="tim-icons icon-app"></i> Headers-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#features">-->
<!--                <i class="tim-icons icon-settings"></i> Features-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#blogs">-->
<!--                <i class="tim-icons icon-align-left-2"></i> Blogs-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#teams">-->
<!--                <i class="tim-icons icon-user-run"></i> Teams-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#projects">-->
<!--                <i class="tim-icons icon-paper"></i> Projects-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#pricing">-->
<!--                <i class="tim-icons icon-money-coins"></i> Pricing-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#testimonials">-->
<!--                <i class="tim-icons icon-chat-33"></i> Testimonials-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#contactus">-->
<!--                <i class="tim-icons icon-mobile"></i> Contact Us-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#tables">-->
<!--                <i class="tim-icons icon-chart-bar-32"></i> Tables-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../sections.html#accordion">-->
<!--                <i class="tim-icons icon-paper"></i> Accordion-->
<!--              </a>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li class="nav-item dropdown">-->
<!--            <a-->
<!--              href="#"-->
<!--              class="nav-link dropdown-toggle"-->
<!--              id="navbarDropdownMenuLink"-->
<!--              data-toggle="dropdown"-->
<!--            >-->
<!--              <i class="tim-icons icon-book-bookmark" aria-hidden="true"></i>-->
<!--              <p>Examples</p>-->
<!--            </a>-->
<!--            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">-->
<!--              <a class="dropdown-item" href="../examples/about-us.html">-->
<!--                <i class="tim-icons icon-bulb-63"></i> About-us-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/blog-post.html">-->
<!--                <i class="tim-icons icon-align-center"></i> Blog Post-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/blog-posts.html">-->
<!--                <i class="tim-icons icon-chart-bar-32"></i> Blog Posts-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/contact-us.html">-->
<!--                <i class="tim-icons icon-square-pin"></i> Contact Us-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/landing-page.html">-->
<!--                <i class="tim-icons icon-paper"></i> Landing Page-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/pricing.html">-->
<!--                <i class="tim-icons icon-coins"></i> Pricing-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/ecommerce.html">-->
<!--                <i class="tim-icons icon-basket-simple"></i> Ecommerce Page-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/product-page.html">-->
<!--                <i class="tim-icons icon-bag-16"></i> Product Page-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/profile-page.html">-->
<!--                <i class="tim-icons icon-lock-circle"></i> Profile Page-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/error.html">-->
<!--                <i class="tim-icons icon-button-power"></i> 404 Error Page-->
<!--              </a>-->
<!--              <a class="dropdown-item" href="../examples/500-error.html">-->
<!--                <i class="tim-icons icon-alert-circle-exc"></i> 500 Error Page-->
<!--              </a>-->
<!--              <a-->
<!--                href="#"-->
<!--                class="dropdown-item dropdown-toggle"-->
<!--                id="navbarDropdown2"-->
<!--                data-toggle="dropdown"-->
<!--              >-->
<!--                <i class="tim-icons icon-book-bookmark" aria-hidden="true"></i> App Pages-->
<!--              </a>-->
<!--              <div class="dropdown-menu" aria-labelledby="navbarDropdown2">-->
<!--                <a class="dropdown-item" href="../examples/account-settings.html">-->
<!--                  <i class="tim-icons icon-lock-circle"></i> Account Settings-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/login-page.html">-->
<!--                  <i class="tim-icons icon-tablet-2"></i> Login Page-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/register-page.html">-->
<!--                  <i class="tim-icons icon-laptop"></i> Register Page-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/reset-page.html">-->
<!--                  <i class="tim-icons icon-molecule-40"></i> Reset Page-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/invoice-page.html">-->
<!--                  <i class="tim-icons icon-notes"></i> Invoice Page-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/checkout-page.html">-->
<!--                  <i class="tim-icons icon-basket-simple"></i> Checkout Page-->
<!--                </a>-->
<!--                <a class="dropdown-item" href="../examples/chat-page.html">-->
<!--                  <i class="tim-icons icon-email-85"></i> Chat Page-->
<!--                </a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </li>-->
<!--          <li class="nav-item">-->
<!--            <a-->
<!--              class="nav-link btn btn-sm btn-default"-->
<!--              href="https://www.creative-tim.com/product/blk-design-system-pro"-->
<!--              target="_blank"-->
<!--            >-->
<!--              <p>Buy Now</p>-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  </nav>-->
<!--</template>-->
<!--<script>-->
<!--import { CollapseTransition } from 'vue2-transitions';-->

<!--export default {-->
<!--  name: 'base-nav',-->
<!--  props: {-->
<!--    show: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--      description:-->
<!--        'Whether navbar menu is shown (valid for viewports < specified by `expand` prop)'-->
<!--    },-->
<!--    transparent: {-->
<!--      type: Boolean,-->
<!--      default: false,-->
<!--      description: 'Whether navbar is transparent'-->
<!--    },-->
<!--    expand: {-->
<!--      type: String,-->
<!--      default: 'lg',-->
<!--      description: 'Breakpoint where nav should expand'-->
<!--    },-->
<!--    menuClasses: {-->
<!--      type: [String, Object, Array],-->
<!--      default: '',-->
<!--      description:-->
<!--        'Navbar menu (items) classes. Can be used to align menu items to the right/left'-->
<!--    },-->
<!--    containerClasses: {-->
<!--      type: [String, Object, Array],-->
<!--      default: 'container-fluid',-->
<!--      description:-->
<!--        'Container classes. Can be used to control container classes (contains both navbar brand and menu items)'-->
<!--    },-->
<!--    type: {-->
<!--      type: String,-->
<!--      default: 'white',-->
<!--      validator(value) {-->
<!--        return [-->
<!--          'dark',-->
<!--          'success',-->
<!--          'danger',-->
<!--          'warning',-->
<!--          'white',-->
<!--          'primary',-->
<!--          'info',-->
<!--          'vue'-->
<!--        ].includes(value);-->
<!--      },-->
<!--      description: 'Navbar color type'-->
<!--    }-->
<!--  },-->
<!--  model: {-->
<!--    prop: 'show',-->
<!--    event: 'change'-->
<!--  },-->
<!--  components: {-->
<!--    CollapseTransition-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      transitionFinished: true,-->
<!--      scrolled: false,-->
<!--      scrollThreshold: 50,-->
<!--    };-->
<!--  },-->
<!--  computed: {-->
<!--    navbarClasses() {-->
<!--      return {-->
<!--        'navbar-transparent': !this.scrolled,-->
<!--        'navbar-colored': this.scrolled,-->
<!--      };-->
<!--    },-->
<!--    classes() {-->
<!--      let color = `bg-${this.type}`;-->
<!--      let classes = [-->
<!--        { 'navbar-transparent': !this.show && this.transparent },-->
<!--        { [`navbar-expand-${this.expand}`]: this.expand }-->
<!--      ];-->
<!--      if (this.position) {-->
<!--        classes.push(`navbar-${this.position}`);-->
<!--      }-->
<!--      if (-->
<!--        !this.transparent ||-->
<!--        (this.show && !this.transitionFinished) ||-->
<!--        (!this.show && !this.transitionFinished)-->
<!--      ) {-->
<!--        classes.push(color);-->
<!--      }-->
<!--      return classes;-->
<!--    },-->

<!--  },-->
<!--  methods: {-->
<!--    toggleMenu() {-->
<!--      this.$emit('change', !this.show);-->
<!--    },-->
<!--    onTransitionStart() {-->
<!--      this.transitionFinished = false;-->
<!--    },-->
<!--    onTransitionEnd() {-->
<!--      this.transitionFinished = true;-->
<!--    },-->
<!--    handleScroll() {-->

<!--      this.scrolled = window.scrollY > this.scrollThreshold;-->
<!--      console.log(this.scrolled)-->
<!--    },-->
<!--  },-->
<!--  mounted() {-->
<!--    console.log('sdfsd')-->
<!--    window.addEventListener('scroll', this.handleScroll);-->
<!--  },-->
<!--  beforeDestroy() {-->
<!--    window.removeEventListener('scroll', this.handleScroll);-->
<!--  },-->
<!--};-->
<!--</script>-->
<!--<style scoped>-->

<!--.fixed-top {-->
<!--  position: fixed;-->
<!--  top: 0;-->
<!--  right: 0;-->
<!--  left: 0;-->
<!--  z-index: 1030;-->
<!--}-->
<!--</style>-->
